import React from "react";
import {Router} from "@reach/router";
import Home from "./Components/Home";
import Country from "./Components/Country";
import "./app.css";

const App = () => {
    return (
        <Router>
            <Home path="/" default />
            <Country path="/country/:name" />
        </Router>
    );
};

export default App;
